/* ============================================================
   MANDINGA — storefront interactions (Horizon implementation)
   Design interactions from Claude Design handoff, wired to the
   real Shopify AJAX cart and product variants.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var SUN_SVG = '<svg viewBox="0 0 80 54" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round">'
    + '<path d="M22 42 a18 18 0 0 1 36 0"/><line x1="6" y1="42" x2="74" y2="42"/>'
    + '<line x1="40" y1="5" x2="40" y2="13"/><line x1="21" y1="11" x2="25" y2="18"/>'
    + '<line x1="59" y1="11" x2="55" y2="18"/><line x1="8" y1="25" x2="16" y2="28"/>'
    + '<line x1="72" y1="25" x2="64" y2="28"/></svg>';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.MANDINGA_MONEY_FORMAT) {
      return Shopify.formatMoney(cents, window.MANDINGA_MONEY_FORMAT);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- scroll reveals (visible by default, gated by .reveal-on) ---------- */
  var revs = $$('.rev');
  var vh = function () { return window.innerHeight || document.documentElement.clientHeight || 800; };
  function revealCheck() {
    for (var i = 0; i < revs.length; i++) {
      var el = revs[i];
      if (!el.classList.contains('in') && el.getBoundingClientRect().top < vh() * 0.92) el.classList.add('in');
    }
  }
  if (revs.length) {
    document.body.classList.add('reveal-on');
    revealCheck();
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('load', function () { revealCheck(); setTimeout(revealCheck, 200); });
    setTimeout(revealCheck, 300);
  }


  /* ---------- cart drawer (real Shopify cart) ---------- */
  function openOverlay(d) {
    if (!d) return;
    d.style.display = 'block';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('open'); }); });
  }
  function closeOverlay(d) {
    if (!d) return;
    d.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function () { if (!d.classList.contains('open')) d.style.display = ''; }, 520);
  }
  function openCart() { var d = $('#cart'); if (!d) return; openOverlay(d); refreshCart(); }
  function closeCart() { closeOverlay($('#cart')); }

  function renderCount(c) {
    $$('.cart-c').forEach(function (el) { el.textContent = c; el.style.display = c ? 'grid' : 'none'; });
  }

  function renderDrawer(cart) {
    var body = $('#cart-body'); if (!body) return;
    var foot = $('#cart-foot');
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="sun" aria-hidden="true">' + SUN_SVG + '</div>'
        + '<p>Your bag is empty.</p><span>Handmade pieces from $6, ready to ship from Bondi.</span></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<div class="cart-row">'
        + '<div class="cr-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>'
        + '<div class="cr-info"><div class="cr-nm">' + i.product_title + '</div>'
        + '<div class="cr-pr tnum">' + money(i.final_price) + '</div>'
        + '<div class="cr-qty"><button data-key="' + i.key + '" data-to="' + (i.quantity - 1) + '" aria-label="Decrease">−</button>'
        + '<span class="tnum">' + i.quantity + '</span>'
        + '<button data-key="' + i.key + '" data-to="' + (i.quantity + 1) + '" aria-label="Increase">+</button>'
        + '<button class="cr-rm" data-key="' + i.key + '" data-to="0">Remove</button></div></div></div>';
    }).join('');
    var totalEl = $('#cart-total');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCount(cart.item_count); renderDrawer(cart); })
      .catch(function () {});
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var old = btn ? (btn.getAttribute('data-label') || btn.innerHTML) : null;
    if (btn) { btn.classList.add('adding'); btn.innerHTML = '<span class="spin" aria-hidden="true">' + SUN_SVG + '</span>'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        if (btn) {
          btn.classList.remove('adding'); btn.classList.add('added');
          btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg> Added';
          setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = old; openCart(); }, 650);
        } else { openCart(); }
      })
      .catch(function () {
        if (btn) { btn.classList.remove('adding'); btn.innerHTML = old; }
      });
  }

  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  var cbody = $('#cart-body');
  if (cbody) cbody.addEventListener('click', function (e) {
    var t = e.target.closest('button[data-key]'); if (!t) return;
    changeLine(t.getAttribute('data-key'), parseInt(t.getAttribute('data-to'), 10));
  });

  /* ---------- product variants ---------- */
  var variantData = [];
  var vEl = $('#mandinga-variants');
  if (vEl) { try { variantData = JSON.parse(vEl.textContent); } catch (e) { variantData = []; } }
  var selected = {};

  function currentVariant() {
    if (!variantData.length) return null;
    if (variantData.length === 1) return variantData[0];
    return variantData.filter(function (v) {
      return v.options.every(function (opt, idx) { return selected[idx] === opt; });
    })[0] || null;
  }

  function syncVariant() {
    var v = currentVariant();
    var atc = $('#main-atc');
    var priceEl = $('#pdp-price');
    var stickyPrice = $('#sticky-price');
    if (!v) {
      if (atc) { atc.setAttribute('disabled', ''); atc.textContent = 'Unavailable'; }
      return;
    }
    if (priceEl) priceEl.textContent = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (atc) {
      atc.setAttribute('data-variant-id', v.id);
      if (v.available) {
        atc.removeAttribute('disabled');
        var lbl = 'Add to bag  ·  ' + money(v.price);
        atc.setAttribute('data-label', lbl); atc.innerHTML = lbl;
      } else {
        atc.setAttribute('disabled', ''); atc.textContent = 'Sold out';
      }
    }
    var sticky = $('#sticky-cta .btn');
    if (sticky) sticky.setAttribute('data-variant-id', v.id);
  }

  $$('.swatch, .opt-pill').forEach(function (s) {
    s.addEventListener('click', function () {
      var idx = parseInt(s.getAttribute('data-opt-index') || '0', 10);
      var group = s.closest('[data-opt-group]') || document;
      $$('.swatch, .opt-pill', group).forEach(function (x) { x.classList.remove('on'); });
      s.classList.add('on');
      selected[idx] = s.getAttribute('data-value') || s.getAttribute('data-name');
      var lab = $('#swatch-lab');
      if (lab && idx === 0) lab.textContent = s.getAttribute('data-name') || s.getAttribute('data-value');
      syncVariant();
    });
  });
  /* seed initial selection from any pre-marked .on options */
  $$('.swatch.on, .opt-pill.on').forEach(function (s) {
    selected[parseInt(s.getAttribute('data-opt-index') || '0', 10)] = s.getAttribute('data-value') || s.getAttribute('data-name');
  });
  syncVariant();

  /* ---------- add-to-cart triggers (delegated, so appended cards work) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    var host = btn.closest('[data-product]') || document;
    var qtyEl = host.querySelector('[data-qty-val]');
    var vid = btn.getAttribute('data-variant-id') || host.getAttribute('data-variant-id');
    addToCart(vid, qtyEl ? parseInt(qtyEl.textContent, 10) : 1, btn);
  });

  refreshCart();

  /* ---------- collection + search: lazy load more (append in place) ---------- */
  (function () {
    var more = $('.col-more');
    if (!more) return;
    var gridSel = more.getAttribute('data-grid') || '.col-grid';
    var grid = $(gridSel);
    if (!grid) return;
    var trigger = more.querySelector('.btn');
    var fill = more.querySelector('.bar i');
    var lab = more.querySelector('.lab');
    var nextUrl = trigger ? trigger.getAttribute('href') : null;
    var busy = false;
    function load() {
      if (busy || !nextUrl) return;
      busy = true;
      if (trigger) trigger.textContent = 'Loading…';
      fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector(gridSel);
        if (incoming) {
          Array.prototype.slice.call(incoming.children).forEach(function (c) { c.classList.add('in'); grid.appendChild(c); });
        }
        var nm = doc.querySelector('.col-more');
        var nb = nm ? nm.querySelector('.btn') : null;
        nextUrl = nb ? nb.getAttribute('href') : null;
        if (nm) {
          var nf = nm.querySelector('.bar i'); if (fill && nf) fill.style.width = nf.style.width;
          var nl = nm.querySelector('.lab'); if (lab && nl) lab.textContent = nl.textContent;
        }
        busy = false;
        if (nextUrl && trigger) { trigger.textContent = 'Load more'; trigger.setAttribute('href', nextUrl); }
        else if (trigger) { trigger.style.display = 'none'; }
      }).catch(function () { busy = false; if (trigger) trigger.textContent = 'Load more'; });
    }
    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); load(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '700px' });
      io.observe(more);
    }
  })();

  /* ---------- mobile nav ---------- */
  var mnav = $('#mnav');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openOverlay(mnav); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closeOverlay(mnav); }); });

  /* ---------- gallery ---------- */
  var main = $('#pg-main');
  if (main) {
    $$('.pg-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.pg-thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var img = main.querySelector('img');
        if (img) img.src = t.getAttribute('data-full');
      });
    });
    /* preload the full-size images so switching thumbnails is instant (otherwise
       each click downloads the 900px image on demand and lags). The featured image
       in the markup keeps its own load priority; these are small (~3ms each) so we
       fire them right away rather than waiting for window.load. */
    $$('.pg-thumb').forEach(function (t) {
      var u = t.getAttribute('data-full');
      if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; }
    });
    /* desktop only: magnify the image on hover. The `hover:none` guard means touch
       devices skip it; the .pg-main frame (overflow:hidden + clip-path) keeps the
       scaled image inside the box. (The MOBILE tap-zoom stays removed — it escaped
       the frame off-screen on iOS Safari, which doesn't clip transformed children.) */
    main.addEventListener('mousemove', function (e) {
      if (window.matchMedia('(hover:none)').matches) return;
      var img = main.querySelector('img');
      if (!img) return;
      var r = main.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      img.style.transform = 'scale(1.7)';
    });
    main.addEventListener('mouseleave', function () { var img = main.querySelector('img'); if (img) img.style.transform = ''; });

    /* mobile: swipe to change image */
    if ('ontouchstart' in window) {
      var sx = 0, sy = 0, moved = false;
      main.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false; }, { passive: true });
      main.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) moved = true; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        var thumbs = $$('.pg-thumb');
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && thumbs.length > 1) {
          var cur = 0; thumbs.forEach(function (th, i) { if (th.classList.contains('on')) cur = i; });
          var next = dx < 0 ? cur + 1 : cur - 1;
          if (next < 0) next = thumbs.length - 1;
          if (next >= thumbs.length) next = 0;
          thumbs[next].click();
        }
      });
    }
  }

  /* ---------- qty stepper ---------- */
  $$('[data-qty]').forEach(function (grp) {
    var val = grp.querySelector('[data-qty-val]');
    var dec = grp.querySelector('[data-qty-dec]');
    var inc = grp.querySelector('[data-qty-inc]');
    if (dec) dec.addEventListener('click', function () { val.textContent = Math.max(1, parseInt(val.textContent, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { val.textContent = parseInt(val.textContent, 10) + 1; });
  });

  /* ---------- sticky mobile CTA ---------- */
  var sticky = $('#sticky-cta');
  var atcMain = $('#main-atc');
  if (sticky && atcMain && 'IntersectionObserver' in window) {
    var sObs = new IntersectionObserver(function (es) {
      sticky.classList.toggle('show', !es[0].isIntersecting && window.matchMedia('(max-width:860px)').matches);
    }, { threshold: 0 });
    sObs.observe(atcMain);
  }

  /* ---------- cart page: apply a discount code ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-promo]');
    if (!btn) return;
    var inp = document.getElementById('promo-code');
    var code = inp && inp.value.trim();
    if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'promo-code') {
      e.preventDefault();
      var code = e.target.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
  });

  /* ---------- search page: clear button (show only when field has text) ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-search-clear]');
    if (!c) return;
    var form = c.closest('form');
    var inp = form && form.querySelector('input[type="search"]');
    if (inp) { inp.value = ''; c.hidden = true; inp.focus(); }
  });
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.srch-box input[type="search"]')) return;
    var c = inp.closest('.srch-box').querySelector('[data-search-clear]');
    if (c) c.hidden = !inp.value;
  });
})();
